import React from "react";
import { Modal } from "react-bootstrap";
import WorkBookService from "../../../services/exam/WorkBookService";
import realResultViewStates, { realResultViewProps } from "./RatingEstimatesRealResultViewModal.models";
import './RatingEstimatesRealResultViewModal.scss';

export default class realResultViewModal extends React.PureComponent<realResultViewProps, realResultViewStates>{
    workBookService: WorkBookService;
    constructor(props: realResultViewProps) {
        super(props);
        this.workBookService = new WorkBookService();
        this.state = { results: [] }
    }

    componentDidMount() {
        var workBookId = this.props.id;
        if (workBookId !== null && workBookId !== undefined)
            this.getData();
    }

    componentDidUpdate(prevState: realResultViewProps) {
        var workBookId = this.props.id;
        var prevWorkBookId = prevState.id;
        if (workBookId !== prevWorkBookId && workBookId !== null && workBookId !== undefined)
            this.getData();
    }

    getData = () => {
        let state = this;
        this.workBookService.getById(this.props.id as string).then(response => {
            state.setState({ results: response });
        })
    }

    render(): React.ReactNode {
        let { showModal, closeModal } = this.props;
        let { results } = this.state
        return <>
            <Modal show={showModal} onHide={closeModal} animation={true}>
                <Modal.Body>
                    <div className="col-12 rating-estimates-real-result-modal">
                        <div className="title-modal">
                            <label>کارنامه ی کنکور</label>
                        </div>
                        <div className="col-12 user-info">
                            <div className="tk-inline">
                                <div className="col-6 notspace course-title">
                                    <label>درس</label>
                                </div>
                                <div className="col-6 notspace description">
                                    <label>چندتا از 10 تا</label>
                                </div>
                            </div>
                            {results.map((course, key) => {
                                return (
                                    <div key={key} className="tk-inline">
                                        <div className="col-6 notspace">
                                            <label>{course.title} : </label>
                                        </div>
                                        <div className="col-6 notspace info">
                                            <label>{course.value}</label>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-primary tk-float-left" onClick={closeModal}>بستن</button>
                </Modal.Footer>
            </Modal>
        </>
    }
}